<template>
  <div :class="['tp-right-header', isFirstPage ? 'isFirstPage' : '']" :style="{height: headerHeight, paddingTop: headerHeight == '122px' ? '26px': '32px'}">
    <template v-if="isFirstPage">
      <div class="header">
        <div class="header-left">
          <div>
            <div class="tp-header-title" v-if="showBack">
              <span  class="tp-header-back" @click="handleBack"></span>
              <span :style="{fontSize: showBack ? '18px' : '24px', background: titleWithBackgroundColor ? '#f0f2f5' : '#ffffff'}">{{ name }}
              </span>
            </div>
            <span class="name" v-else>{{name}}</span>
          </div>
          <div class="header-tab">
            <common-tabs
            v-if="list.length"
            :activTabsId="activTabsId"
            :list='list'
            @handleClick="handlerBarClick">
            </common-tabs>
          </div>
        </div>
        <div class="header-right">
          <div class="header-btn-list">
            <common-button v-if="showImpport"  @click="importLoads">{{importLoadsText}}</common-button>
            <!-- <div v-if="showImpport"  @click="importLoads" class="import-load">{{importLoadsText}}</div> -->
            <div v-if="showAddBtn" @click="headerRightBtn" class="tp-add-btn">{{addTips}}</div>
          </div>
          <div class="tp-header-view" v-if="showViewList">
            <ul class="tp-header-ul">
              <li
                  v-for="item in viewList"
                  :key="item.id"
                  @click="changeView(item.id)"
                  :class="[activeView == item.id ? 'is-active' : '']">{{ item.name }}
              </li>
            </ul>
          </div>
        </div>
        <slot></slot>
        <slot name="self"></slot>
      </div>
    </template>
    <template v-else>
      <div class="tp-header-box">
        <div class="tp-header-left">
          <div class="tp-header-title">
            <span v-if="showBack" class="tp-header-back" @click="handleBack"></span>
            <span :style="{fontSize: showBack ? '18px' : '24px', background: titleWithBackgroundColor ? '#f0f2f5' : '#ffffff'}">{{ name }}
            </span>
          </div>
          <slot name="_showID"></slot>
          <div class="tp-select-box" v-if="showSelect">
            <header-select
                :selectValue="selectValue"
                :isDisabeldTop="isDisabeldTop"
                @changeHeaderSelect="changeHeaderSelect"
                :disabeldSelete="disabeldSelete"
                :list="selectList"
                :colorList="colorList"></header-select>
          </div>
          <div class="tp-call-btn" v-if="callBtnCallBack" @click="callBtnCallBack">
            <svg-icon class="tp-call-btn-icon" name="call"/>
            Call
          </div>
          <slot></slot>
        </div>
        <div class="tp-header-btn">
          <slot name="button"></slot>
          <!-- {{hover}} -->
          <div v-if="showImpport"  @click="importLoads" class="import-load"><span style="font-weight: 500;">Import Loads</span></div>
          <div v-if="showDuplicate" @click="Duplicate" class="duplicete"><span>Duplicate</span></div>
          <div v-if="showImportBtn" @click="headerImport" class="tp-import-btn">{{importTips}}</div>
          <el-tooltip el-tooltip  :disabled="isDisabeldTop" :content="isDisabeldTop ? '' : 'No Permission'" placement="bottom">
            <div>
              <div v-if="showAddBtn" @click="headerRightBtn" :class="{'tp-add-btn': true, 'tp-add-btn-disabled': !isDisabeldTop ? true : false}" :style="isDisabeldTop ? '' : 'cursor: not-allowed'">{{addTips}}</div>
            </div>
          </el-tooltip>
        </div>
      </div>
      <!--    通过slot穿dom进来，可以通过绝对定位布局-->
      <slot name="self"></slot>
      <div v-if="showTips" class="tp-header-tips">
        {{ tips }}
      </div>
      <div style="min-height: 32px">
        <common-tabs
            v-if="list.length"
            :activTabsId="activTabsId"
            :list='list'
            @handleClick="handlerBarClick">
        </common-tabs>
      </div>
      <div class="tp-header-view" v-if="showViewList">
        <ul class="tp-header-ul">
          <li
              v-for="item in viewList"
              :key="item.id"
              @click="changeView(item.id)"
              :class="[activeView == item.id ? 'is-active' : '']">{{ item.name }}
          </li>
        </ul>
      </div>
    </template>
  
  </div>
</template>
<script>

import commonTabs from "../common-tabs/index";
import HeaderSelect from "./headerSelect";

export default {
  data() {
    return {
      activeView: '0',
      hover: false,
      viewList: [
        {
          id: '0',
          name: 'List'
        },
        {
          id: '1',
          name: 'Map'
        },
      ],
      statusList: []
    }
  },
  components: {
    HeaderSelect,
    commonTabs
  },
  name: 'commonHeader',
  props: {
    activTabsId: {
      type: String,
      default: ''
    },
    showViewList: {
      type: Boolean,
      default: true
    },
    showDuplicate: {
      type: Boolean,
      default: false
    },
    addTips: {
      type: String,
      default: 'Add New Load'
    },
    importTips: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: 'Loads'
    },
    titleWithBackgroundColor: {
      type: Boolean,
      default: false
    },
    showAddBtn: {
      type: Boolean,
      default: true
    },
    showImportBtn: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default: () => []
    },
    activeViewIndex: {
      type: String,
      default: 'map'
    },
    colorList: {
      type: Array,
    },
    selectList: {   // 下拉选列表
      type: Array,
      default: () => ['Completed', 'Pending', 'Accepted', 'in Transit', 'Decilned']
    },
    selectValue: {    // 下拉选默认项
      type: String,
      default: ''
    },
    showSelect: {   // 显示下拉选择
      type: Boolean,
      default: false
    },
    callBtnCallBack: {
      type: Function,
    },
    showBack: {     // 显示回退按钮
      type: Boolean,
      default: false
    },
    showImpport: {
      type: Boolean,
      default: false,
    },
    showTips: {
      type: Boolean,
      default: false
    },
    tips: {
      type: String,
      default: ''
    },
    headerHeight: {
      type: String,
      default: '144px'
    },
    importLoadsText: {
      type: String,
      default: 'Import Loads'
    },
    disabeldSelete: {
      type: Boolean,
      default: false
    },
    isDisabeldTop: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isFirstPage() {
      return this.headerHeight == '72px'
    }
  },
  watch: {
    activeViewIndex: {
      handler(val) {
        if (val) {
          const index = this.viewList.find(res => res.name == val)
          this.activeView = index.id
        }
      }
    },
  },
  methods: {
    handleBack() {
      this.$emit('handleBack')
    },
    importLoads() {
      this.$emit('importLoad')
    },
    changeHeaderSelect(data) {
      this.$emit('changeHeaderSelect', data)
    },
    handlerBarClick(node) {
      this.$emit('changeBarClick', node)
    },
    changeView(val) {
      this.activeView = val
      const index = this.viewList.find(res => res.id == this.activeView)
      this.$emit('changeView', index.name)
    },
    headerRightBtn() {
      if(!this.isDisabeldTop) return
      this.$emit('headerRightClick')
    },
    headerImport() {
      this.$emit('headerImport')
    },
    Duplicate() {
      this.$emit('Duplicate')
    },
    dup() {
      this.hover = true
    },
    dupt() {
      this.hover = false
    }
  }
}
</script>
<style lang="scss" scoped>
.tp-right-header {
  background-color: #ffffff;
  padding: 32px 24px 0 24px;
  width: 100%;
  /*height: 144px;*/
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06), inset 0 -1px 0 0 #dadce1;
}

.tp-header-back {
  display: inline-block;
  cursor: pointer;
  height: 24px;
  width: 24px;
  background: url("../../assets/img/tp-header/arrow.svg") no-repeat;
  margin-right: 6px;
}

.tp-header-view {
  position: absolute;
  right: 24px;
  bottom: 12px;
}

.tp-header-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.tp-header-left {
  display: flex;
  justify-content: center;
  align-items: center;

}

.tp-header-title {
  color: #000000;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    user-select: text;
    font-size: 32px;
    font-weight: bold;
  }
}

.tp-header-btn {
  display: flex;

  & > div {
    margin-left: 16px;
  }
}

.tp-select-box {
  align-self: center;
  margin-left: 16px;
}
.tp-call-btn {
  background: #4066D4;
  border-radius: 14px;
  height: 28px;
  width: 84px;
  margin-left: 8px;
  display: flex;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  color: white;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &-icon {
    height: 18px;
    width: 18px;
    margin-right: 3px;
  }

}

.tp-add-btn {
  background: url("../../assets/img/tp-header/add.svg") no-repeat;
  background-position: 18px center;
  background-size: 16px 16px;
  background-color: #4066d4;
  color: #fff;
  padding: 9px 18px 9px 40px;
  font-size: 14px;
  line-height: 22px;
  border-radius: 2px;
  font-weight: 500;
  font-stretch: normal;
  cursor: pointer;
  font-weight: bold !important;
  &:hover {
    background-color: #0076ff;
  }
}
.tp-add-btn-disabled {
  background-color: #dadce1 !important;
}

.duplicete {
  width: 128px;
  height: 40px;
  cursor: pointer;
  text-align: center;
  border-radius: 2px;
  border: solid 1px #dadce1;
  background: url("../../assets/img/com-2/duplicate.svg") no-repeat;
  background-position: 15px 10px;

  img {
    vertical-align: middle;
    margin-top: -4px;
  }

  span {
    font-weight: 500;
    font-size: 16px;
    color: #4c556c;
    line-height: 40px;
    margin-left: 22px;
  }

  span:hover {
    color: #4066d4;
  }
}
.import-load{
  background: url("../../assets/img/tp-header/icon-16-import.svg") no-repeat;
  background-position: 18px center;
  background-size: 16px 16px;
  color: #4c556c;
  padding: 9px 18px 9px 40px;
  font-size: 14px;
  line-height: 22px;
  border-radius: 2px;
  // font-weight: 500;
  font-stretch: normal;
  cursor: pointer;
  font-weight: 500;
  border: solid 1px #dadce1;

  
}
.import-load:hover {
  border: solid 1px #4066d4;
  background: url("../../assets/img/tp-header/import-blue.svg") no-repeat;
  background-position: 18px center;
  span {
    color: #4066d4;
  }
}
.duplicete:hover {
  border: solid 1px #4066d4;
  background: url("../../assets/img/com-2/blue.svg") no-repeat;
  background-position: 15px 10px;
  span {
    color: #4066d4;
  }
}

  .import-load{
    background: url("../../assets/img/tp-header/icon-16-import.svg") no-repeat;
    background-position: 18px center;
    background-size: 16px 16px;
    color: #7F8596;
    padding: 9px 18px 9px 40px;
    font-size: 14px;
    line-height: 22px;
    border-radius: 2px;
    // font-weight: 500;
    font-stretch: normal;
    cursor: pointer;
    font-weight: bold;
    border: solid 1px #dadce1;
    display: flex;
    align-items: center;
  }
  .import-load:hover {
    border: solid 1px #4066d4;
    background: url("../../assets/img/tp-header/import-blue.svg") no-repeat;
    background-position: 18px center;
    // span {
      color: #4066d4;
    // }
  }

.tp-import-btn {
  background: url("../../assets/img/tp-header/import.svg") no-repeat;
  background-position: 18px center;
  background-size: 16px 16px;
  background-color: rgba(0, 94, 233, 0.1);
  font-size: 16px;
  border-radius: 2px;
  padding: 9px 18px 9px 40px;
  font-weight: 500;
  line-height: 22px;
  font-stretch: normal;
  cursor: pointer;
  color: #4066d4;
  font-weight: 500;

}

.tp-header-ul {
  li {
    font-weight: bold;
    cursor: pointer;
    display: inline-block;
    font-size: 14px;
    padding: 6px 11.5px 6px 33.5px;
    background-size: 16px 16px;
    background-position: 12px center;
    background-repeat: no-repeat;
    border: 1px solid #dadce1;
    color: #7F8596;
  }

  li:first-child {
    border-right: 0 none;
    border-top-left-radius: 2px;
    border-bottom-left-radius: 2px;
    background-image: url("../../assets/img/tp-header/list.svg");
    border-right: 0 none;

    &.is-active {
      background-image: url("../../assets/img/tp-header/list-active.svg");
      border: solid 1px #4066d4;
      color: #4066d4;
    }

    &:hover {
      background-image: url("../../assets/img/tp-header/list-active.svg");
      color: #4066d4;
    }
  }

  li:last-child {
    border-top-right-radius: 2px;
    border-bottom-right-radius: 2px;
    background-image: url("../../assets/img/tp-header/map.svg");
    border-left: 0 none;

    &.is-active {
      background-image: url("../../assets/img/tp-header/map-active.svg");
      border: solid 1px #4066d4;
      color: #4066d4;
    }

    &:hover {
      color: #4066d4;
      background-image: url("../../assets/img/tp-header/map-active.svg");
    }
  }
}

.tp-header-tips {
  font-weight: normal;
  font-size: 14px;
  color: #4c556c;
  line-height: 1.43;
  padding-left: 30px;
  margin-top: 4px;
}
</style>
<style lang="scss" scoped>
.isFirstPage.tp-right-header{
  padding: 21px 24px 0px 24px !important;
  flex-direction: row;

  .header{
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    position: relative;
  }

  .header-left{
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
  }

  .name{
    color: #000000;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
  }
  .nameColor{
    color: #000000;
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    background: #F5F7FA;
  }

  .header-tab{
    padding-top: 7px;
    margin-left: 50px;
  }

  .header-right {
    display: flex;
    z-index: 2;
  }

  .header-btn-list{
    display: flex;


    .import-load{
      padding-left: 12px;
      background-image: none;
    }

    .tp-add-btn{
      background-position: 12px center;
    }

    & > div{
      padding: 7px 12px 7px 34px;
      height: 36px;
      margin-left: 18px;

      &:first-child{
        margin-left: 0;
      }

      *{
        font-weight: bold;
        font-size: 14px;
        line-height: 22px;
      }
    }
  }

  .tp-header-view{
    position: static;
    padding-left: 24px;
    margin-left: 24px;
    border-left: 1px solid #dadce1;
    li {
      padding: 6px 12px 6px 32px;
      line-height: 22px;
    } 
  }

  /deep/ {
    .el-tabs__nav-prev,.el-tabs__nav-next{
      display: none;
    }
    .tp-tabs{
      width: auto;
      height: 44px;
      margin-bottom: 0;
    }
    .el-tabs__nav{
      display: flex;
    }
    .tp-tabs .el-tabs__item{
      height: 44px;
    }
  }
}
</style>
